import React, { useEffect, useRef, useCallback, useState } from 'react'
import { useParams } from "react-router-dom"

import Grid from '@material-ui/core/Grid'
import SendIcon from '@material-ui/icons/Send'

import PendenciaService from "@services/PendenciaService"

import Title from "@base/Title"
import Toast from "@base/Toast"
import { ButtonSave } from "@base/Button/ButtonForm"

import EmailView from '@pages/Pendencia/Email/EmailView'

import { ProcessoResolver } from "@helpers/ProcessoHelper"

export const Email = (props) => {
    const params = useParams();
    const processo = ProcessoResolver(params.processo);

    const [id, ] = useState(props.id ?? params.id);

    const [to, setTo] = useState("");
    const [type, setType] = useState("");
    const [status, setStatus] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    
    const [loadingButtonSender, setLoadingButtonSender] = useState(false);

    const toastRef = useRef(null);
    
    const handleSendMail = () => {
        setLoadingButtonSender(true)

        const mail = {
            para: to,
            tipoEmail: type,
            assunto: subject,
            mensagem: message,
        }

        PendenciaService.reenviarEmail(processo.id, id, mail)
            .then(res => {
                toastRef.current.show("success", "O Reenvio de Email foi Configurado e em Instantes será Realizado")
            })
            .catch(e => {
                toastRef.current.show("error", "Ocorreu um Problema ao Configurar o Reenvio do Email. Tente Novamente Mais Tarde")
            })
            .finally(() => setLoadingButtonSender(false))
    }
    
    const carregaDados = useCallback(() => {
        if (id) {            
            PendenciaService.buscarEmail(processo.id, id)
                .then(res => {
                    setSubject(res.data.titulo);
                    setMessage(res.data.corpo);
                    setStatus(res.data.statusEnvio);
                    setType(res.data.processo);
                    setTo(res.data.para);
                })
                .catch(error => {
                    toastRef.current.show("error", "Ocorreu um Problema ao Buscar Informações do Email. Tente Novamente Mais Tarde")
                })
        }
    }, [id, processo]);

    useEffect(() => carregaDados(), [carregaDados])

    const page =  type ?  'Detalhes do Email Enviado' : "Envio de E-mail";

    return (
        <>
            <Toast ref={toastRef} />
            
            {!props.id &&
                <>
                    <Title>{page}</Title>
                    <br />
                </>
            }

            {type ?  
            <EmailView 
                to={to}
                status={status}
                type={type}
                subject={subject} 
                message={message}
            /> : <>Nenhum e-mail foi enviado anteriormente</>}

            <Grid container spacing={3} alignItems='flex-end' style={{ marginTop: 16 }}>
                <Grid item sm={12} lg={4}>
                    <ButtonSave
                        startIcon={<SendIcon />}
                        onClick={handleSendMail}
                        name={type ?  "Reenviar Este Email" : "Enviar e-mail"}
                        loading={loadingButtonSender}
                    />
                </Grid> 
            </Grid>
        </>
    )
}

export default Email;